/* eslint-disable @typescript-eslint/no-explicit-any */
import { _getCacheKey } from './cache'
import { _FetchConfigData, _RequestDefinition } from './types'

export const _registerRefresh =
  (fetchConfigData: _FetchConfigData) => (key: string, fn: () => void) => {
    const { refreshMap } = fetchConfigData
    if (!refreshMap.has(key)) refreshMap.set(key, new Set())
    refreshMap.get(key)!.add(fn)
  }

export const _unregisterRefresh =
  (fetchConfigData: _FetchConfigData) => (key: string, fn: () => void) => {
    const { refreshMap } = fetchConfigData
    refreshMap.get(key)?.delete(fn)
  }

export const _createRefreshApi =
  (fetchConfigData: _FetchConfigData) =>
  (
    def: _RequestDefinition<any, any, any>,
    {
      urlParams,
      fetchParams
    }: {
      urlParams?: any
      fetchParams?: any
    } = {}
  ) => {
    const { cache, refreshMap } = fetchConfigData

    const cacheKey = _getCacheKey({
      url: def.url,
      method: def.method,
      urlParams,
      fetchParams
    })

    Array.from(cache.keys()).forEach(key => {
      if (key.startsWith(cacheKey)) {
        cache.delete(key)
      }
    })

    Array.from(refreshMap.keys()).forEach(key => {
      if (key.startsWith(cacheKey)) {
        refreshMap.get(key)?.forEach((fn) => fn())
      }
    })
  }
